<template>
  <div class="transition-all">
    <div
      :class="
        'sidebar q-sidebar transition-all shadow-lg ' +
          (readingExperience.question ? 'sidebar-show' : 'sidebar-hide')
      "
    >
      <div class="d-flex justify-content-center flex-column p-3">
        <div class="row d-flex align-items-center m-2 mt-4">
          <div class="col-md-2">
            <button
              class="btn br-button-primary text-white shadow-lg border-radius-2 d-flex align-items-center justify-content-center"
              @click="hide"
            >
              <i class="fas fa-chevron-left fa-2x"></i>
            </button>
          </div>
          <div class="col-md-8">
            <h1 class="text-center">Preguntas</h1>
          </div>
        </div>
        <div class="container" v-if="readingExperience.currentQuestion.id">
          <BrQuestionItem
            :data_object="readingExperience.currentQuestion"
          ></BrQuestionItem>
        </div>
        <div class="sidebar-panel" v-else>
          <h3 class="text-center mx-4">
            No hay preguntas en el presente capítulo.
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import BrQuestionItem from "./BrQuestionItem";

export default {
  tame: "br-question-container",
  components: {
    BrQuestionItem,
  },
  props: {
    item_data: {},
  },
  computed: {
    ...mapState(["readingExperience"]),
  },
  methods: {
    ...mapMutations(["showQuestion"]),
    hide() {
      this.showQuestion();
    },
  },
};
</script>

<style lang="css"></style>
